import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGender } from "../interfaces/gender";

@Injectable({
  providedIn: 'root'
})
export class GenderService {
    private rootUrl: string = "/api/genders";

    constructor(private httpClient: HttpClient) { }

    public getGenders(): Observable<IGender[]> {
        const url = this.rootUrl;
        return this.httpClient.get<IGender[]>(url);
    }
}
